export function getIcon(name) {
  const CATEGORY = [
    // 'green', 'blue-plus', 'yellow'
    { name: '温度', unit: '℃', icon: 'thermometer', color: 'svg-blue' },
    { name: '湿度', unit: '%', icon: 'humidity', color: 'svg-green' },
    { name: '风速', unit: 'm/s', icon: 'wind', color: 'svg-yellow' },
    { name: '风向', unit: '°', icon: 'windsock', color: 'svg-purple' },
    { name: '雨量', unit: 'mm', icon: 'rain', color: 'svg-blue-plus' },
    { name: '大气压', unit: 'Kpa', icon: 'pressure', color: 'svg-pink' },
    { name: '光照', unit: 'Klux', icon: 'sun', color: 'svg-yellow' },
    { name: '⽇照时数', unit: 'Klux', icon: 'sun', color: 'svg-yellow' },
    { name: '土壤盐分', unit: 'ms/cm', icon: 'sali', color: 'svg-blue' }
  ]

  return CATEGORY.find(c => name && name.includes(c.name)) || { icon: '' }
}

export const colors = [
  '#8190ff',
  '#ff9b87',
  '#82c36a',
  '#009be9',
  '#E6A23C',
  '#909399',
  '#ea7ccc',
  '#9a60b4',
  '#fc8452'
]
